import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable } from 'rxjs';
import { filter, switchMap, switchMapTo, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private authService: AuthService, private afAuth: AngularFireAuth) {}
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.isLoggedIn$.pipe(
      filter((isLoggedIn) => !!isLoggedIn),
      switchMapTo(this.afAuth.idToken),
      take(1),
      switchMap((token) => {
        if (
          req.url.endsWith('upload-truck-document') ||
          req.url.endsWith('upload') ||
          req.url.endsWith('upload_document') ||
          req.url.endsWith('propx/upload_eog') ||
          req.url.endsWith('propx/upload_sandi') ||
          req.url.endsWith('propx/upload_solaris') ||
          req.url.endsWith('propx/upload_cig')
        ) {
          const copyWithAuthOnly = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
              'web-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
              'web-timezone-offset-minutes': `${new Date().getTimezoneOffset()}`,
            },
          });
          return next.handle(copyWithAuthOnly);
        }
        const copy = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            'Content-Type': req.headers.get('Content-Type') || 'application/json',
            'web-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
            'web-timezone-offset-minutes': `${new Date().getTimezoneOffset()}`,
          },
        });
        return next.handle(copy);
      }),
    );
  }
}
